(function () {
  var tabsRoot = document.querySelector('[data-recipe-tabs]');
  if (!tabsRoot) return;

  var tabsSection = tabsRoot.closest('.shopify-section') || tabsRoot;
  var homeParent = tabsRoot.parentNode;
  var placeholder = document.createElement('div');
  placeholder.className = 'recipe-tabs-placeholder';
  placeholder.setAttribute('aria-hidden', 'true');

  var nav = tabsRoot.querySelector('[data-recipe-tabs-nav]');
  var links = nav ? Array.prototype.slice.call(nav.querySelectorAll('[data-recipe-tab]')) : [];
  var sections = links
    .map(function (link) {
      var id = (link.getAttribute('href') || '').replace('#', '');
      return id ? document.getElementById(id) : null;
    })
    .filter(Boolean);

  function visibleHeaderBottom() {
    var header = document.querySelector('.section-header') || document.querySelector('sticky-header');
    if (!header) return 0;
    if (header.classList.contains('shopify-section-header-hidden')) return 0;
    var opacity = parseFloat(getComputedStyle(header).opacity);
    if (opacity === 0) return 0;
    var rect = header.getBoundingClientRect();
    if (rect.bottom <= 0 || rect.top >= 160) return 0;
    return Math.max(0, Math.round(rect.bottom));
  }

  function headerLayoutHeight() {
    var header = document.querySelector('.section-header') || document.querySelector('sticky-header');
    if (!header) return 0;
    return Math.max(0, Math.round(header.offsetHeight));
  }

  function markerDocY() {
    var el = placeholder.parentNode ? placeholder : tabsSection;
    return el.getBoundingClientRect().top + (window.pageYOffset || window.scrollY || 0);
  }

  function pinTabs(top, tabsH) {
    if (!placeholder.parentNode && homeParent) {
      if (tabsRoot.parentNode === homeParent) {
        homeParent.insertBefore(placeholder, tabsRoot);
      } else {
        homeParent.insertBefore(placeholder, homeParent.firstChild);
      }
    }
    placeholder.style.height = tabsH + 'px';
    if (tabsRoot.parentNode !== document.body) {
      document.body.appendChild(tabsRoot);
    }
    tabsRoot.classList.add('is-stuck');
    tabsRoot.style.top = top + 'px';
  }

  function unpinTabs() {
    if (!tabsRoot.classList.contains('is-stuck') && !placeholder.parentNode) return;
    tabsRoot.classList.remove('is-stuck');
    tabsRoot.style.top = '';
    if (placeholder.parentNode) {
      if (tabsRoot.parentNode !== homeParent) {
        homeParent.insertBefore(tabsRoot, placeholder);
      }
      placeholder.parentNode.removeChild(placeholder);
    } else if (homeParent && tabsRoot.parentNode !== homeParent) {
      homeParent.insertBefore(tabsRoot, homeParent.firstChild);
    }
    placeholder.style.height = '0px';
  }

  function syncStickyTabs() {
    var tabsH = tabsRoot.offsetHeight || 0;
    var headerBottom = visibleHeaderBottom();
    var headerH = headerLayoutHeight();
    var stickyOffset = headerBottom + tabsH + 'px';
    document.documentElement.style.setProperty('--recipe-tabs-height', tabsH + 'px');
    document.documentElement.style.setProperty('--recipe-sticky-offset', stickyOffset);
    var main = document.getElementById('MainContent');
    if (main) {
      main.style.setProperty('--recipe-tabs-height', tabsH + 'px');
      main.style.setProperty('--recipe-sticky-offset', stickyOffset);
    }

    var scrollY = window.pageYOffset || window.scrollY || 0;
    var originY = markerDocY();
    var shouldStick = scrollY >= 8 && scrollY >= originY - headerH - 1;

    if (shouldStick) {
      pinTabs(headerBottom, tabsH);
    } else {
      unpinTabs();
    }
  }

  function headerOffset() {
    var tabsH = tabsRoot.offsetHeight || 0;
    document.documentElement.style.setProperty('--recipe-tabs-height', tabsH + 'px');
    return visibleHeaderBottom() + tabsH + 12;
  }

  function setActive(id) {
    var allLinks = document.querySelectorAll('[data-recipe-tab]');
    Array.prototype.forEach.call(allLinks, function (link) {
      var match = link.getAttribute('href') === '#' + id;
      link.classList.toggle('is-active', match);
      if (match) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
  }

  function bindLinkClicks(root) {
    var navLinks = root.querySelectorAll('[data-recipe-tab]');
    Array.prototype.forEach.call(navLinks, function (link) {
      if (link.getAttribute('data-recipe-tab-bound')) return;
      link.setAttribute('data-recipe-tab-bound', 'true');
      link.addEventListener('click', function (event) {
        var id = (link.getAttribute('href') || '').replace('#', '');
        var target = document.getElementById(id);
        if (!target) return;
        event.preventDefault();
        var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        setActive(id);
      });
    });
  }

  bindLinkClicks(tabsRoot);

  if (sections.length && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        var visible = entries
          .filter(function (entry) {
            return entry.isIntersecting;
          })
          .sort(function (a, b) {
            return b.intersectionRatio - a.intersectionRatio;
          })[0];
        if (visible && visible.target && visible.target.id) setActive(visible.target.id);
      },
      {
        rootMargin: '-30% 0px -55% 0px',
        threshold: [0.1, 0.25, 0.5]
      }
    );
    sections.forEach(function (section) {
      observer.observe(section);
    });
  }

  var ticking = false;
  function onScrollOrResize() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      syncStickyTabs();
      ticking = false;
    });
  }

  syncStickyTabs();
  window.addEventListener('scroll', onScrollOrResize, { passive: true });
  window.addEventListener('resize', onScrollOrResize);
  window.addEventListener('load', syncStickyTabs);

  var headerEl = document.querySelector('.section-header') || document.querySelector('sticky-header');
  if (headerEl && 'MutationObserver' in window) {
    new MutationObserver(onScrollOrResize).observe(headerEl, {
      attributes: true,
      attributeFilter: ['class']
    });
  }
})();
